import { Component, type ErrorInfo, type ReactNode } from 'react'

type RootErrorBoundaryProps = {
  children: ReactNode
  area: string
  compact?: boolean
}

type RootErrorBoundaryState = {
  failed: boolean
}

export class RootErrorBoundary extends Component<
  RootErrorBoundaryProps,
  RootErrorBoundaryState
> {
  state: RootErrorBoundaryState = { failed: false }

  static getDerivedStateFromError(): RootErrorBoundaryState {
    return { failed: true }
  }

  componentDidCatch(error: unknown, errorInfo: ErrorInfo) {
    console.error(`WorkSmarter: не удалось отобразить ${this.props.area}`, error, errorInfo)
  }

  private reloadFresh = () => {
    const refreshUrl = new URL('/', window.location.origin)
    refreshUrl.searchParams.set('refresh', String(Date.now()))
    window.location.assign(refreshUrl)
  }

  render() {
    if (!this.state.failed) return this.props.children

    if (this.props.compact) {
      return (
        <section className="module-error" role="alert">
          <strong>Раздел временно не загрузился</strong>
          <span>Остальная часть WorkSmarter продолжает работать.</span>
          <button className="text-button" type="button" onClick={this.reloadFresh}>
            Обновить раздел
          </button>
        </section>
      )
    }

    return (
      <main className="loading-screen startup-error" role="alert">
        <div className="logo-mark">WS</div>
        <h1>WorkSmarter не удалось запустить</h1>
        <p>Загрузите свежую версию страницы. Локальные клиенты и задачи не удалятся.</p>
        <button className="button primary" type="button" onClick={this.reloadFresh}>
          Загрузить свежую версию
        </button>
      </main>
    )
  }
}
